export const GENERIC_ERROR_MESSAGE_KEY = _TL_("We've encountered an error and can't continue. Please contact support for further assistance.");

export const getErrorsPlaceholders = () => ({
  systemErrors: [],
  serverErrors: [],
});

export const CAMPAIGN_NEGATIVE_REFERENCE_ID = -1;
export const KEYWORDS_SHOW_COUNT = 100;
